const DAY = 86_400_000;
export const dayFloor = (t: number) => Math.floor(t / DAY) * DAY;

// Windows are calendar ranges keyed by their start; some (this week/month)
// extend past today, which the chart draws as a dashed projection. The endpoint
// takes the resolved start/end day boundaries.
export type WindowOption = { value: string; label: string; phrase: string };

export const WINDOW_OPTIONS: WindowOption[] = [
  { value: "7", label: "7 days", phrase: "in the last 7 days" },
  { value: "30", label: "30 days", phrase: "in the last 30 days" },
  { value: "this_week", label: "This week", phrase: "this week" },
  { value: "last_week", label: "Last week", phrase: "last week" },
  { value: "this_month", label: "This month", phrase: "this month" },
  { value: "last_month", label: "Last month", phrase: "last month" },
];

export function windowOption(
  param: string | undefined,
  fallback = "this_week"
): WindowOption {
  return (
    WINDOW_OPTIONS.find((option) => option.value === param) ??
    WINDOW_OPTIONS.find((option) => option.value === fallback)!
  );
}

// Week starts Monday; all boundaries are UTC to align with the day-grained ledger.
function startOfWeek(day0: number): number {
  const sinceMonday = (new Date(day0).getUTCDay() + 6) % 7;
  return day0 - sinceMonday * DAY;
}
function startOfMonth(day0: number): number {
  const d = new Date(day0);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1);
}
function endOfMonth(day0: number): number {
  const d = new Date(day0);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0);
}

export function windowRange(
  value: string,
  today0: number
): { start: number; end: number } {
  switch (value) {
    case "7":
      return { start: today0 - 6 * DAY, end: today0 };
    case "this_week": {
      const s = startOfWeek(today0);
      return { start: s, end: s + 6 * DAY };
    }
    case "last_week": {
      const s = startOfWeek(today0) - 7 * DAY;
      return { start: s, end: s + 6 * DAY };
    }
    case "this_month":
      return { start: startOfMonth(today0), end: endOfMonth(today0) };
    case "last_month": {
      const prev = startOfMonth(today0) - DAY;
      return { start: startOfMonth(prev), end: endOfMonth(prev) };
    }
    default:
      return { start: today0 - 29 * DAY, end: today0 };
  }
}
